import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  // Label defaults to display: flex, which collapses the whitespace around the inline
  // <strong>Policy restrictions:</strong> so the text runs up against the colon (a documented
  // Label gotcha in staff-fe/CLAUDE.md). display: block restores normal inline flow so the
  // space is preserved; pre-wrap keeps the source line breaks in multi-line restriction text.
  text: {
    display: 'block',
    whiteSpace: 'pre-wrap',
    padding: theme.spacing(1, 0)
  }
}));

export default useStyles;
